/* =====================================================
   BEOCCA AWWWARDS - Interaction Engine
   Lightweight vanilla JS for premium animations
   No external dependencies required
   ===================================================== */

(function() {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // =====================================================
  // SCROLL REVEAL - IntersectionObserver based
  // =====================================================
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('[data-aww-reveal]');
    const staggerElements = document.querySelectorAll('[data-aww-stagger]');
    const goldLines = document.querySelectorAll('.aww-gold-line');
    const headingReveals = document.querySelectorAll('.aww-heading-reveal');
    const imageReveals = document.querySelectorAll('.aww-image-reveal');
    const compareElements = document.querySelectorAll('.aww-compare-enhanced');
    const quoteElements = document.querySelectorAll('.aww-quote-section');
    const footerElements = document.querySelectorAll('.aww-footer-reveal');
    const testimonials = document.querySelectorAll('.aww-testimonial');
    const iconBounce = document.querySelectorAll('.aww-icon-bounce');

    const allElements = [
      ...revealElements, ...staggerElements, ...goldLines,
      ...headingReveals, ...imageReveals, ...compareElements,
      ...quoteElements, ...footerElements, ...testimonials, ...iconBounce
    ];

    if (allElements.length === 0) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.awwDelay;
          if (delay) {
            setTimeout(function() {
              entry.target.classList.add('is-visible');
            }, parseInt(delay));
          } else {
            entry.target.classList.add('is-visible');
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    allElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // =====================================================
  // TEXT SPLIT ANIMATION
  // =====================================================
  function initTextSplit() {
    var splitElements = document.querySelectorAll('.aww-split-text');

    splitElements.forEach(function(el) {
      var text = el.textContent.trim();
      var words = text.split(' ');
      el.innerHTML = '';
      el.setAttribute('aria-label', text);

      words.forEach(function(word, wordIndex) {
        var wordSpan = document.createElement('span');
        wordSpan.className = 'aww-word';
        wordSpan.setAttribute('aria-hidden', 'true');

        for (var i = 0; i < word.length; i++) {
          var charSpan = document.createElement('span');
          charSpan.className = 'aww-char';
          charSpan.textContent = word[i];
          charSpan.style.transitionDelay = (wordIndex * 0.08 + i * 0.03) + 's';
          wordSpan.appendChild(charSpan);
        }

        el.appendChild(wordSpan);

        // Add space between words
        if (wordIndex < words.length - 1) {
          var space = document.createTextNode('\u00A0');
          el.appendChild(space);
        }
      });
    });

    // Use IntersectionObserver to trigger
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    splitElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // =====================================================
  // PARALLAX SCROLL
  // =====================================================
  function initParallax() {
    var parallaxElements = document.querySelectorAll('[data-aww-parallax]');
    if (parallaxElements.length === 0) return;

    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;

      parallaxElements.forEach(function(el) {
        var speed = parseFloat(el.dataset.awwParallax) || 0.3;
        var rect = el.getBoundingClientRect();
        var elementTop = rect.top + scrollY;
        var offset = (scrollY - elementTop) * speed;

        // Only transform when element is roughly in view
        if (rect.top < window.innerHeight + 200 && rect.bottom > -200) {
          el.style.transform = 'translateY(' + offset + 'px)';
        }
      });

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }


  // =====================================================
  // MAGNETIC BUTTON EFFECT
  // =====================================================
  function initMagneticButtons() {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var magneticElements = document.querySelectorAll('.aww-magnetic');

    magneticElements.forEach(function(el) {
      el.addEventListener('mousemove', function(e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        var strength = 0.3;

        el.style.transform = 'translate(' + (x * strength) + 'px, ' + (y * strength) + 'px)';
      });

      el.addEventListener('mouseleave', function() {
        el.style.transform = 'translate(0, 0)';
      });
    });
  }

  // =====================================================
  // 3D TILT EFFECT
  // =====================================================
  function initTiltEffect() {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var tiltElements = document.querySelectorAll('.aww-tilt');

    tiltElements.forEach(function(el) {
      el.addEventListener('mousemove', function(e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var tiltX = (y - 0.5) * 10; // Max 5 degrees
        var tiltY = (x - 0.5) * -10;

        el.style.transform = 'perspective(1000px) rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg) scale3d(1.02, 1.02, 1.02)';
      });

      el.addEventListener('mouseleave', function() {
        el.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1, 1, 1)';
      });
    });
  }

  // =====================================================
  // NUMBER COUNTER ANIMATION
  // =====================================================
  function initCounters() {
    var counters = document.querySelectorAll('.aww-counter');
    if (counters.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.dataset.awwTarget) || 0;
          var suffix = el.dataset.awwSuffix || '';
          var prefix = el.dataset.awwPrefix || '';
          var duration = 2000;
          var start = 0;
          var startTime = null;

          function animate(currentTime) {
            if (!startTime) startTime = currentTime;
            var elapsed = currentTime - startTime;
            var progress = Math.min(elapsed / duration, 1);
            // Ease out cubic
            var easedProgress = 1 - Math.pow(1 - progress, 3);
            var current = Math.round(start + (target - start) * easedProgress);

            el.textContent = prefix + current.toLocaleString((window.theme && window.theme.locale) || undefined) + suffix;

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          }

          requestAnimationFrame(animate);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(el) {
      observer.observe(el);
    });
  }


  // =====================================================
  // HERO FLOATING ELEMENTS
  // =====================================================
  function initHeroFloats() {
    var heroSection = document.querySelector('.aww-hero-section');
    if (!heroSection) return;

    var floatHTML = '<div class="aww-hero-float aww-hero-float--1"></div>' +
                   '<div class="aww-hero-float aww-hero-float--2"></div>' +
                   '<div class="aww-hero-float aww-hero-float--3"></div>';

    // Find the slideshow slide or hero inner
    var slideInner = heroSection.querySelector('.slideshow__slide') || heroSection;
    if (slideInner.style.position !== 'relative' && getComputedStyle(slideInner).position === 'static') {
      slideInner.style.position = 'relative';
    }
    slideInner.insertAdjacentHTML('beforeend', floatHTML);

    // Animate in after a short delay
    setTimeout(function() {
      var floats = heroSection.querySelectorAll('.aww-hero-float');
      floats.forEach(function(f) { f.classList.add('is-visible'); });
    }, 500);
  }

  // =====================================================
  // ENHANCED PRODUCT CARDS
  // =====================================================
  function initProductCards() {
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      card.classList.add('aww-product-card');
    });
  }

  // =====================================================
  // INITIALIZE ALL
  // =====================================================
  function init() {
    // Wait for DOM ready
    initScrollReveal();
    initTextSplit();
    initParallax();
    initMagneticButtons();
    initTiltEffect();
    initCounters();
    initHeroFloats();
    initProductCards();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section load (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(init, 200);
    });
  }

})();
